import { ScrollView } from 'react-native'

const MyScrollView = ({ children, ...props }) => {
  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}
      {...props}
    >
      {children}
    </ScrollView>
  )
}

export default MyScrollView
